<template>
	<div>
		<bread-crumbs
			:title="$t('OnDemand.NotAssignedVisits')"
			:subTitle="$t('general.SubtitleOnDemand')"
			:sizeTitle="30"
			:lineHeightTitle="37"
			:sizeSubTitle="15"
			:lineHeightSubTitle="18"
		></bread-crumbs>
		<vx-card no-shadow>
			<div class="mt-5 mb-5">
				<vs-navbar v-model="activeItem" class="p-2" type="flat">
					<div slot="title">
						<vs-navbar-title>
							<h4>{{ $t("Date") }}: {{ currentClock }}</h4>
						</vs-navbar-title>
					</div>

					<vs-navbar-item index="5">
						<vx-tooltip delay=".1s" :text="$t('OnDemand.AvailableResources')" position="bottom">
							<vs-button
								v-show="oldSelected"
								class="mr-2"
								color="dark"
								size="medium"
								type="border"
								icon-pack="feather"
								icon="icon-search"
								@click="activeFilterPromptTrigger += 1"
							>
								{{ $t("OnDemand.SearchResources") }}</vs-button
							>
						</vx-tooltip>
					</vs-navbar-item>

					<vs-navbar-item index="0">
						<vx-tooltip
							position="bottom"
							delay=".1s"
							:text="$t('OnDemand.ChangeDateText')"
							:title="$t('OnDemand.ChangeDate')"
						>
							<vs-button
								class="w-full mr-1"
								color="dark"
								size="large"
								type="flat"
								icon-pack="feather"
								icon="icon-calendar"
								radius
								@click="activePopupDate = true"
							></vs-button>
						</vx-tooltip>
					</vs-navbar-item>

					<vs-navbar-item index="1">
						<vx-tooltip delay=".1s" :text="$t('PopupScheduleTitleCreate')">
							<vs-button
								class="w-full mr-1"
								color="dark"
								size="large"
								type="flat"
								icon-pack="feather"
								icon="icon-plus-square"
								radius
								@click="popupActive = true"
							></vs-button>
						</vx-tooltip>
					</vs-navbar-item>

					<vs-navbar-item index="2">
						<vx-tooltip delay=".1s" :text="$t('Schedule.Refresh')">
							<vs-button
								class="w-full"
								color="dark"
								size="large"
								type="flat"
								icon-pack="feather"
								icon="icon-refresh-cw"
								radius
								@click="refresh"
							></vs-button>
						</vx-tooltip>
					</vs-navbar-item>

					<vs-navbar-item index="3">
						<vx-tooltip
							delay=".1s"
							:text="isEventsListSidebarActive ? $t('OnDemand.HideList') : $t('OnDemand.ShowList')"
						>
							<vs-button
								class="w-full"
								color="dark"
								icon-pack="feather"
								icon="icon-list"
								size="large"
								type="flat"
								radius
								@click="isEventsListSidebarActive = !isEventsListSidebarActive"
							></vs-button>
						</vx-tooltip>
					</vs-navbar-item>

					<vs-navbar-item index="4">
						<vs-button
							class="w-full"
							color="dark"
							icon-pack="feather"
							icon="icon-eye"
							size="large"
							type="flat"
							radius
							:title="$t('Zonification.View') + ' ' + $t('OnDemand.AssignedVisits')"
							@click.prevent="$router.push({name: 'apps-on-demand-history'})"
						></vs-button>
					</vs-navbar-item>
					<vs-navbar-item index="5">
						<vs-dropdown vs-custom-content :vs-trigger-click="false" class="cursor-pointer">
							<vx-tooltip delay=".1s" :text="$t('Schedule.Refresh')">
								<vs-button
									class="w-full"
									color="dark"
									size="large"
									type="flat"
									icon-pack="feather"
									icon="icon-settings"
									radius
									@click="isEventsListSidebarActive = !isEventsListSidebarActive"
								></vs-button>
							</vx-tooltip>

							<vs-dropdown-menu style="width: 30%">
								<vx-card no-shadow :title="$t('Setting.Setting')">
									<div class="flex flex-row justify-between p-1">
										<p class="mr-2">{{ $t("OnDemand.AutomaticAllocation") }}</p>
										<vs-switch color="success" v-model="automatically" @input="openConfirm">
											<!-- <span slot="on">{{ $t("OnDemand.Enabled") }}</span>
													<span slot="off">{{ $t("OnDemand.Disabled") }}</span> -->
										</vs-switch>
									</div>
									<div class="flex flex-row justify-between p-1">
										<p class="mr-2">{{ $t("OnDemand.HideVisitListOnSelect") }}</p>
										<vs-switch color="success" v-model="hideVisitListOnSelect"> </vs-switch>
									</div>
								</vx-card>
							</vs-dropdown-menu>
						</vs-dropdown>
					</vs-navbar-item>
				</vs-navbar>
			</div>

			<div class="vx-row not-assignment-content" v-if="communicationReadPermission">
				<div class="vx-col w-full">
					<vx-card no-shadow card-border class="not-assignment-content--messages-content" id="chat-app">
						<vs-sidebar
							class="items-no-padding events-sidebar"
							parent="chat-app"
							:hidden-background="clickNotClose"
							v-model="isEventsListSidebarActive"
							click-not-close
							position-right
							default-index="1"
							color="primary"
							spacer
						>
							<vx-card no-shadow card-border :title="$t('List')">
								<div class="flex flex-row justify-between mb-4">
									<p>
										<span class="font-semibold"> {{ $t("InitDate") }}:</span>
										<span> {{ dateInit }}</span>
									</p>
									<p>
										<span class="font-semibold"> {{ $t("EndDate") }}:</span>
										<span> {{ dateEnd }}</span>
									</p>
								</div>
								<div class="hidden lg:block">
									<vx-input-group class="mb-base">
										<vs-input
											:placeholder="$t('Search')"
											v-model="searchQuery"
											icon="icon-search"
											icon-pack="feather"
											class="w-full"
										/>

										<template slot="append">
											<div class="append-text btn-addon">
												<event-filter-form :handle-action="handleAction"></event-filter-form>
											</div>
										</template>
									</vx-input-group>
								</div>
								<vs-divider class="d-theme-border-grey-light mb-2" />
								<p>
									<vs-alert
										class="mt-2"
										color="primary"
										:title="$t('OnDemand.AutomaticAllocation') + ' ' + $t('OnDemand.Enabled')"
										:active.sync="enableOnDemandAutomaticAssignmentAlert"
										closable
										icon-pack="feather"
										close-icon="icon-x"
									>
										<span>{{ $t("OnDemand.AutomaticAllocationTextAlert") }}</span>
									</vs-alert>
								</p>
								<vue-perfect-scrollbar class="scroll-area--content-left" :settings="settings">
									<vs-table
										v-if="notAssigmentsEvents.length > 0 && loadingEvents"
										:data="notAssigmentsEvents"
										v-model="selected"
										@selected="handleSelected"
									>
										<template slot="thead">
											<vs-th>N</vs-th>
											<vs-th>{{ $t("Activity.Activity") }}</vs-th>
											<vs-th>{{ $t("Hour") }}</vs-th>
										</template>

										<template slot-scope="{data}">
											<vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
												<vs-td>
													{{ indextr + 1 }}
												</vs-td>
												<vs-td :data="tr.activity_name">
													{{ tr.activity_name.toLowerCase() | capitalize }}
												</vs-td>
												<vs-td :data="tr.init_hour">
													{{ tr.init_hour }}
												</vs-td>

												<template slot="expand">
													<div class="con-expand-users w-full">
														<div class="con-btns-user flex items-center justify-between">
															<div class="con-userx flex items-center justify-start">
																<vs-avatar :badge="tr.visit_point_name" size="45px" />
																<span>{{ tr.visit_point_name | capitalize }}</span>
															</div>
															<div class="flex">
																<vx-tooltip delay=".1s" :text="$t('Schedule.Reassign')">
																	<vs-button
																		type="border"
																		size="small"
																		icon-pack="feather"
																		icon="icon-edit"
																		color="success"
																		class="mr-2"
																		@click="openPopupEditEvent(tr)"
																	></vs-button>
																</vx-tooltip>
																<vx-tooltip
																	delay=".1s"
																	:text="$t('Schedule.DeleteVisit')"
																>
																	<vs-button
																		type="border"
																		size="small"
																		icon-pack="feather"
																		icon="icon-trash"
																		color="danger"
																		@click="openConfirmDelete"
																	></vs-button>
																</vx-tooltip>
															</div>
														</div>
														<vs-list>
															<vs-list-item
																icon-pack="feather"
																icon="icon-mail"
																:title="tr.date_prog"
															></vs-list-item>
															<vs-list-item
																icon-pack="feather"
																icon="icon-globe"
																:title="fullAddress(tr) | capitalize"
															></vs-list-item>
														</vs-list>
													</div>
												</template>
											</vs-tr>
										</template>
									</vs-table>
									<p v-else class="mt-2">
										<vs-alert class="mt-2" color="primary" icon-pack="feather" icon="icon-info">
											<span>{{ $t("OnDemand.NoFoundEvents") }}</span>
										</vs-alert>
									</p>
								</vue-perfect-scrollbar>
							</vx-card>
						</vs-sidebar>

						<event-management-item
							v-if="getOnDemandConfig"
							:event="selectedEvent"
							:onDemandConfig="getOnDemandConfig"
							:isEventsListSidebarActive="isEventsListSidebarActive"
							:activeFilterPromptTrigger="activeFilterPromptTrigger"
							@removeSelected="removeSelected"
						></event-management-item>
					</vx-card>
				</div>
			</div>

			<not-permission v-else></not-permission>

			<vs-popup fullscreen :title="popupTitle" :active.sync="popupActive" class="vs-popup--content-custom">
				<event-form
					v-if="popupActive"
					:dataEvent="dataEvent"
					:day="selectedDay"
					parentComponent="ON_DEMAND"
					@changePopupActiveEmit="changePopupActive"
					@fullscreenChangeEmit="fullscreenChange"
				/>
			</vs-popup>

			<vs-prompt
				:title="$t('OnDemand.ChangeDate')"
				@cancel="closePrompt"
				@accept="acceptPrompt"
				@close="closePrompt"
				:active.sync="activePopupDate"
				:acceptText="$t('Accept')"
				:cancelText="$t('Cancel')"
				:is-valid="!validateDates"
			>
				<div>
					<p>
						{{ $t("OnDemand.SelectDateRange") }}
					</p>
					<vs-row vs-w="12">
						<vs-col class="mt-4">
							<small class="date-label">{{ $t("InitDate") }}</small>
							<datepicker
								:language="$vs.rtl ? langHe : langEn"
								name="init-date"
								v-model="init_date"
							></datepicker>
						</vs-col>
						<vs-col class="mt-4 mb-4">
							<small class="date-label">{{ $t("EndDate") }}</small>
							<datepicker
								:language="$vs.rtl ? langHe : langEn"
								name="end-date"
								v-model="end_date"
								:disabled="!init_date"
							></datepicker>

							<span class="text-danger text-sm" v-show="validateDates">{{
								$t("Reports.EndDateGreaterInitDate")
							}}</span>
						</vs-col>
					</vs-row>
				</div>
			</vs-prompt>

			<vs-prompt
				:title="$t('Schedule.Reassign')"
				@cancel="closePrompt"
				@accept="editEvent"
				@close="closePrompt"
				:active.sync="activePopupEditEvent"
				:acceptText="$t('Accept')"
				:cancelText="$t('Cancel')"
				:is-valid="validateUpdateEvent"
			>
				<div>
					<vs-row vs-w="12">
						<vs-col>
							<small class="date-label">{{
								($t("Crud.Update") + " " + $t("Date")).toLowerCase() | capitalize
							}}</small>
							<datepicker
								:language="$vs.rtl ? langHe : langEn"
								name="init-date"
								v-model="new_date"
							></datepicker>
						</vs-col>

						<vs-col class="mt-2">
							<small class="date-label">{{ $t("InitHour") }}</small>
							<div class="mt-1">
								<flat-pickr
									:config="configDateTimePicker"
									class="w-full"
									v-model="init_hour"
									name="init_hour"
									:placeholder="$t('Schedule.SelectInitTime')"
								/>
							</div>
							<span class="text-danger text-sm" v-show="init_hour_error">{{
								$t("Schedule.ErrorProcess.InitHourError")
							}}</span>
						</vs-col>

						<vs-col class="mt-2" v-show="init_hour">
							<small class="date-label">{{ $t("EndHour") }}</small>
							<div class="mt-1">
								<flat-pickr
									:config="configDateTimePicker"
									v-model="end_hour"
									class="w-full"
									:placeholder="$t('Schedule.SelectEndTime')"
									name="end_hour"
								/>
							</div>
							<span class="text-danger text-sm" v-show="errors.has('end_hour')">{{
								$t("Schedule.ValidEndOur")
							}}</span>
						</vs-col>
					</vs-row>
				</div>
			</vs-prompt>
		</vx-card>
	</div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import Datepicker from "vuejs-datepicker";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

import {en, es} from "vuejs-datepicker/src/locale";
import firebase from "firebase/app";

// Components
import NotPermission from "@/views/pages/NotPermission.vue";
import EventItem from "./EventItem.vue";
import EventManagementItem from "./EventManagementItem.vue";
import OnDemandLandingPage from "./OnDemandLandingPage.vue";
import EventForm from "@/components/calendar/EventForm.vue";

// Store Modules
import moduleResource from "@/store/resource/moduleResource.js";
import moduleSchedule from "@/store/schedule/moduleSchedule.js";
import moduleCompanyConfigCrud from "@/store/company-config-crud/moduleCompanyConfigCrud.js";
import moduleActivity from "@/store/activity/moduleActivity.js";

// Helpers
import Commons from "@/helpers/commons.js";
import DateUtils from "@/helpers/DateUtils.js";

// Models
import Resource from "@/models/Resource.js";
import EventProgrammed from "@/models/EventProgrammed.js";
import EventFilterForm from "./EventFilterForm.vue";
import BreadCrumbs from "../../core/components/BreadCrumbs.vue";
import {clearMap} from "../../core/plugins/ol/OlAnuket";

export default {
	components: {
		EventItem,
		EventManagementItem,
		VuePerfectScrollbar,
		NotPermission,
		OnDemandLandingPage,
		EventForm,
		Datepicker,
		flatPickr,
		EventFilterForm,
		BreadCrumbs,
	},
	data() {
		return {
			activeItem: "",
			activeAlert: true,
			searchQuery: null,
			database: firebase.database(),
			active: true,
			settings: {
				maxScrollbarLength: 60,
				wheelSpeed: 0.7,
			},
			selectedDay: new Date(),
			langHe: es,
			langEn: en,
			dataEvent: {},
			popupActive: false,
			fullscreen: false,
			selectedEvent: new EventProgrammed({}),
			companyId: 0,
			automatically: false,
			enableOnDemandAutomaticAssignmentAlert: false,
			activePopupDate: false,
			init_date: new Date(),
			end_date: new Date(),
			new_date: new Date(),
			disabledDates: {
				to: new Date(2022, 7, 5), // Disable all dates up to specific date
				from: new Date(2022, 7, 27), // Disable all dates after specific date
				//days: [6, 0], // Disable Saturday's and Sunday's
			},
			selected: [],
			oldSelected: null,
			clickNotClose: true,
			isEventsListSidebarActive: true,
			activeFilterPromptTrigger: 0,
			loadingEvents: false,
			hideVisitListOnSelect: false,
			init_hour: null,
			init_hour_error: false,
			end_hour: null,
			configDateTimePicker: {
				enableTime: true,
				enableSeconds: true,
				noCalendar: true,
			},
			activePopupEditEvent: false,
			currentClock: "",
			timeOut: null,
		};
	},
	watch: {
		availableEvents(val) {
			// Si entra un nuevo evento disponible refrescamos la lista haceindo una vueva peticion
			this.getEvents();
		},
		acceptedEvents(val) {
			// Si el evento o visita que fue acptada esta en el listado actual de los eventos disponibles
			// refrescamos la lista haceindo una vueva peticion
			const foundEvent = this.notAssigmentsEvents.find(
				(event) => event.id === this.aceptedEventNotification.events_id[0]
			);
			if (foundEvent && this.aceptedEventNotificationEnable) {
				this.eventWasAcceptedNotify(foundEvent);
			}
			this.$store.commit("changeAceptedEventNotificationEnable", true);
		},
		init_hour(val) {
			if (typeof val === "string" && val !== "") {
				const currentActivity = this.$store.getters["moduleActivity/getActivityById"](
					this.selectedEvent.activity_id
				);
				const activityTime = currentActivity.service_time;
				const [hours, minutes, seconds] = activityTime.split(":");
				// startTime , hours, minutes, seconds

				this.end_hour = DateUtils.addHoursMinutesSecodons(
					val,
					parseInt(hours),
					parseInt(minutes),
					parseInt(seconds)
				);
			}
		},
	},
	computed: {
		popupTitle() {
			return this.$t("PopupScheduleTitleCreate");
		},
		communicationReadPermission() {
			return this.$store.getters.checkPermission("COMMUNICATION_R");
		},
		communicationCreatePermission() {
			return this.$store.getters.checkPermission("COMMUNICATION_C");
		},
		communicationUpdatePermission() {
			return this.$store.getters.checkPermission("COMMUNICATION_U");
		},
		communicationDeletePermission() {
			return this.$store.getters.checkPermission("COMMUNICATION_D");
		},
		notAssigmentsEvents() {
			const data = this.$store.state.moduleSchedule.events;
			if (!this.searchQuery || this.searchQuery.trim().length <= 0) {
				return data;
			}
			return data.filter((r) => {
				return (
					r.activity_name.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
					r.visit_point_name.toLowerCase().includes(this.searchQuery.toLowerCase())
				);
			});
		},
		parseEvent() {
			return function (event) {
				return new EventProgrammed(event);
			};
		},
		resources() {
			return this.$store.state.moduleResource.resources;
		},

		availableEvents() {
			return this.$store.getters.getTotalAvailableEvents;
		},
		acceptedEvents() {
			return this.$store.getters.getAceptedEvents;
		},
		aceptedEventNotification() {
			return this.$store.getters.getAceptedEventNotification;
		},
		aceptedEventNotificationEnable() {
			return this.$store.getters.getAceptedEventNotificationEnable;
		},
		getOnDemandConfig() {
			const onDemandConfig = this.$store.getters["moduleCompanyConfig/onDemandConfig"];
			if (onDemandConfig && onDemandConfig.config_json) {
				return onDemandConfig;
			}
			return null;
		},
		getOnDemandAutomaticAssignmentValue() {
			const onDemandConfig = this.$store.getters["moduleCompanyConfig/onDemandConfig"];
			if (onDemandConfig && onDemandConfig.config_json) {
				const {automatic_assignment} = onDemandConfig.config_json;
				return automatic_assignment;
			} else {
				return false;
			}
		},
		getOnDemandNotifyOnCreateValue() {
			const onDemandConfig = this.$store.getters["moduleCompanyConfig/onDemandConfig"];
			if (onDemandConfig && onDemandConfig.config_json) {
				const {notify_on_create} = onDemandConfig.config_json;
				return notify_on_create;
			} else {
				return false;
			}
		},
		activeSelectedEvent() {
			return function (event) {
				return this.selectedEvent.id === event.id;
			};
		},
		fullAddress() {
			return function (event) {
				return `${event.address} ${event.city}`.toLowerCase();
			};
		},
		validateDates() {
			return this.init_date > this.end_date;
		},
		validateUpdateEvent() {
			return this.end_hour && this.init_hour;
		},
		dateInit() {
			return DateUtils.toDefaultDateTime(this.init_date, "YYYY-MM-DD");
		},
		dateEnd() {
			return DateUtils.toDefaultDateTime(this.end_date, "YYYY-MM-DD");
		},
	},
	methods: {
		fullscreenChange(val) {
			this.fullscreen = val;
		},
		changePopupActive({active}) {
			this.popupActive = active;
		},
		getEvents(init_date = this.selectedDay, end_date = this.selectedDay, filters = null) {
			const payload = {
				init_date: DateUtils.toDefaultDateTime(init_date, "YYYY-MM-DD"),
				end_date: DateUtils.toDefaultDateTime(end_date, "YYYY-MM-DD"),
				event_status_id: [1],
			};

			// Validar si agregamos filtros o no
			if (filters) {
				if (filters.additional_info_filter.length > 0) {
					payload["additional_info_filter"] = filters.additional_info_filter;
				}
				if (filters.additional_info_multiselect.length > 0) {
					payload["additional_info_multiselect"] = filters.additional_info_multiselect;
				}
			}
			clearMap();
			this.openLoading();
			this.loadingEvents = false;
			this.$store
				.dispatch("moduleSchedule/fetchEventsByResourceId", payload)
				.then((res) => {
					this.loadingEvents = true;
					this.closeLoading();
				})
				.catch((err) => {
					this.closeLoading();
					console.error(err);
				});
		},
		stringTimeToDate(stringTime) {
			let newDate = new Date();
			if (typeof stringTime === "string") {
				const [hours, minutes, seconds] = stringTime.split(":");
				newDate = new Date(1995, 11, 17, parseInt(hours), parseInt(minutes), parseInt(seconds));
			}
			return newDate;
		},
		editEvent() {
			const payload = {
				event_id: this.selectedEvent.id,
				date_prog: DateUtils.toDefaultDateTime(this.new_date, "YYYY-MM-DD"),
				init_hour: this.init_hour,
				end_hour: this.end_hour,
			};

			if (this.stringTimeToDate(this.end_hour) <= this.stringTimeToDate(this.init_hour)) {
				this.$vs.notify({
					color: "danger",
					title: this.$t("Schedule.InvalidFields"),
					text: this.$t("Schedule.ValidEndOur"),
				});
				this.activePopupEditEvent = true;
				return;
			}

			this.openLoading();
			this.$store
				.dispatch("moduleSchedule/editEvent", payload)
				.then((res) => {
					this.closeLoading();
					if (res.hasOwnProperty("error") && res.error.length > 0) {
						this.validateErrorMessages(res.error[0].message);
						return;
					}
					this.$vs.notify({
						color: "success",
						title: this.$t("TitleConfirmEventUpdate"),
						text: this.$t("TextConfirmEventUpdate"),
					});
				})
				.catch((err) => {
					this.closeLoading();
					this.showErrorAlert();
				});
		},
		removeEvent() {
			const payload = {
				events: [{event_id: this.selectedEvent.id, resource_id: null}],
			};
			this.openLoading();
			this.$store
				.dispatch("moduleSchedule/removeEvent", payload)
				.then((res) => {
					this.closeLoading();
					if (res.hasOwnProperty("error") && res.error.length > 0) {
						this.validateErrorMessages(res.error[0].message);
						return;
					}
					this.$vs.notify({
						color: "success",
						title: this.$t("TitleConfirmEventDelete"),
						text: this.$t("TextConfirmEventDelete"),
					});

					this.selectedEvent = new EventProgrammed({});
					this.getEvents(this.init_date, this.end_date);
				})
				.catch((err) => {
					this.closeLoading();
					this.showErrorAlert();
				});
		},
		showErrorAlert() {
			this.$vs.notify({
				color: "danger",
				title: this.$t("Schedule.ErrorProcess.Title"),
				text: this.$t("Schedule.ErrorProcess.Text"),
			});
		},
		validateErrorMessages(message) {
			let text = "";
			switch (message) {
				case "activity not available for the resource":
					text = this.$t("Schedule.ActivityNoAvailable");
					break;
				case "init_hour less than current time":
					text = this.$t("Schedule.ErrorProcess.InitHourError");
					this.init_hour_error = true;
					break;
				case "visit point is not related to resource":
					text = this.$t("Schedule.ErrorProcess.VisitpointError");
					break;
				case "resource has no activities":
					text = this.$t("Schedule.ErrorProcess.ResourceActivityError");
					break;
				default:
					text = this.$t("ErrorMessage");
					break;
			}
			this.$vs.notify({
				time: 6000,
				color: "danger",
				title: this.$t("ErrorTitle"),
				text,
			});
		},

		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		setSelectedEvent(event) {
			this.selectedEvent = new EventProgrammed(event);
			if (this.hideVisitListOnSelect) this.isEventsListSidebarActive = false;
		},
		openConfirmDelete() {
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Schedule.DeleteVisit"),
				text: this.$t("Schedule.DeleteVisitTextConfirm"),
				accept: this.removeEvent,
				acceptText: this.$t("Crud.Delete"),
				cancelText: this.$t("Cancel"),
			});
		},
		removeSelected(event) {
			this.selectedEvent = new EventProgrammed(event);
		},
		refresh() {
			this.selectedEvent = new EventProgrammed({});
			this.$store.commit("changeAceptedEventNotificationEnable", true);
			this.end_date = this.selectedDay;
			this.init_date = this.selectedDay;
			this.getEvents();
		},
		eventWasAcceptedNotify(eventAccepted) {
			const dataFilter = {
				ids: [this.aceptedEventNotification.resource_id],
			};
			this.$store
				.dispatch("moduleResource/fetchResourceFilterById", dataFilter)
				.then((res) => {
					const resourceData = res.data.records[0];
					this.$vs.notify({
						color: "success",
						title: `Visita Aceptada`,
						text: `${eventAccepted.activity_name} - ${eventAccepted.init_hour} en ${
							eventAccepted.address
						} fue aceptado por el recurso ${resourceData.name.toUpperCase()}`,
						icon: "info",
						time: 6000,
						position: "top-right",
						fixed: true,
					});
					if (this.selectedEvent.id === eventAccepted.id) {
						this.removeSelected({});
					}
					this.getEvents();
				})
				.catch((err) => {
					console.error(err);
				});
		},
		openConfirm(val) {
			if (this.getOnDemandNotifyOnCreateValue) {
				this.openWarningConfirm();
				this.automatically = false;
				return;
			}
			if (val) {
				this.openEnableConfirm(val);
			} else {
				this.automatically = val;
				this.enableOnDemandAutomaticAssignmentAlert = val;
				this.updateCompanyConfig();
			}
		},
		openEnableConfirm(val) {
			if (val) {
				this.$vs.dialog({
					type: "confirm",
					color: "primary",
					title: this.$t("Confirm"),
					text: `${this.$t("OnDemand.AutomaticAllocationText")}`,
					accept: () => {
						this.automatically = val;
						this.updateCompanyConfig();
					},
					cancel: () => {
						this.automatically = false;
					},
					acceptText: this.$t("Accept"),
					cancelText: this.$t("Cancel"),
				});
			}
		},
		openWarningConfirm() {
			this.$vs.dialog({
				color: "warning",
				title: this.$t("Alert"),
				text: `${this.$t("OnDemand.NotifyOnCreateEnabledWarning")}`,
				accept: () => {},
				acceptText: this.$t("Accept"),
			});
		},
		// Actualiza la configuración de compañia
		updateCompanyConfig() {
			const {type_config_id, config_json, company_id, id} = JSON.parse(JSON.stringify(this.getOnDemandConfig));
			config_json.automatic_assignment = this.automatically;
			this.$vs.loading();
			this.$store
				.dispatch("moduleCompanyConfigCrud/updateCompanyConfig", {type_config_id, config_json, company_id, id})
				.then((res) => {
					this.$vs.loading.close();
					this.$vs.notify({
						color: "success",
						title: this.$t("TitleConfirmCompanyConfigUpdate"),
						text: this.$t("TextConfirmCompanyConfigUpdate"),
					});

					// Actualizamos la configuracion en el listado del estado local de la aplicacion
					this.$store.dispatch("moduleCompanyConfig/updateLocalCompanyConfigList", {
						type_config_id,
						config_json,
						company_id,
						id,
					});

					this.enableOnDemandAutomaticAssignmentAlert = this.automatically;
				})
				.catch((err) => {
					this.$vs.loading.close();
					this.automatically = false;
					Commons.manageError.call(this, err, "CompanyConfigCrudForm", "update");
					console.error(err);
				});
		},
		acceptPrompt() {
			this.getEvents(this.init_date, this.end_date);
		},
		closePrompt() {},
		handleSelected(tr) {
			if (!this.oldSelected) {
				this.setSelectedEvent(tr);
				this.oldSelected = tr;
				return;
			}
			if (this.oldSelected.id !== tr.id) {
				this.setSelectedEvent(tr);
				this.oldSelected = tr;
			}
		},
		/**
		 * TODO: Abre el popup para editar el evento seleccionado de la lista de eventos disponibles
		 * @param {Object} event Evento seleccionado de la lista de eventos disponibles
		 */
		openPopupEditEvent(event) {
			this.selectedEvent = new EventProgrammed(event);
			this.activePopupEditEvent = true;
			this.init_hour = this.selectedEvent.init_hour;
			this.end_hour = this.selectedEvent.end_hour;
		},
		fetchCompanyConfig() {
			// Request all of permissions for configList
			this.$store
				.dispatch("moduleCompanyConfig/fetchCompanyConfigList")
				.then(async (companyConfigList) => {
					// Guardamos la configuracion de la empresa en  las preferencias de la aplicacion indexed db
					await this.$store.dispatch("modulePreferences/saveCompanyConfigListPreferences", companyConfigList);
					const onDemandConfig = this.$store.getters["moduleCompanyConfig/onDemandConfig"];
					if (onDemandConfig && onDemandConfig.config_json) {
						const {automatic_assignment} = onDemandConfig.config_json;
						this.automatically = automatic_assignment;
						this.enableOnDemandAutomaticAssignmentAlert = automatic_assignment;
					}
				})
				.catch((error) => {
					console.error(error);
				});
		},
		/**
		 * TODO: Maneja toda la comunicacion entre los componentes hijos
		 * @param {String} action Nombre de las acciones para la toma de deciciones
		 * @param {Any} payload Data que se recibe desde el componente hijo o desde donde se llame
		 */
		handleAction(action, payload) {
			switch (action) {
				case "APPLY_FILTERS":
					// Buscamos los eventos con los filtros
					this.getEvents(this.init_date, this.end_date, payload);
					break;
				default:
					break;
			}
		},
		/**
		 * @TODO Adds a leading zero to a number if it is less than 10.
		 * @param {number} i - The number to check.
		 * @returns {string|number} - The original number with a leading zero if necessary.
		 */
		checkTime(i) {
			if (i < 10) {
				i = "0" + i;
			}
			return i;
		},
		/**
		 * @TODO Updates the currentClock property with the current date and time.
		 * The date format is "day/month/year hour:minute:second".
		 * The clock is updated every 500 milliseconds.
		 */
		clock() {
			const today = new Date();
			let day = today.getDate();
			let mouth = today.getMonth();
			let year = today.getFullYear();
			mouth = mouth + 1;
			let h = today.getHours();
			let m = today.getMinutes();
			let s = today.getSeconds();
			m = this.checkTime(m);
			s = this.checkTime(s);
			this.currentClock = `${day}/${mouth}/${year} ${h}:${m}:${s}`;
			this.timeOut = setTimeout(this.clock, 500);
		},
	},
	created() {
		if (!moduleResource.isRegistered) {
			this.$store.registerModule("moduleResource", moduleResource);
			moduleResource.isRegistered = true;
		}

		if (!moduleSchedule.isRegistered) {
			this.$store.registerModule("moduleSchedule", moduleSchedule);
			moduleSchedule.isRegistered = true;
		}

		if (!moduleCompanyConfigCrud.isRegistered) {
			this.$store.registerModule("moduleCompanyConfigCrud", moduleCompanyConfigCrud);
			moduleCompanyConfigCrud.isRegistered = true;
		}

		if (!moduleActivity.isRegistered) {
			this.$store.registerModule("moduleActivity", moduleActivity);
			moduleActivity.isRegistered = true;
		}
		this.getEvents();
		if (this.$store.state.moduleActivity.activities.length <= 0) {
			this.$store
				.dispatch("moduleActivity/fetchActivityListItems")
				.then((res) => {})
				.catch((err) => {
					console.error(err);
				});
		}
		const onDemandConfig = this.$store.getters["moduleCompanyConfig/onDemandConfig"];
		if (!onDemandConfig) {
			this.fetchCompanyConfig();
		}
	},
	mounted() {
		this.$store.commit("resetAvailableEventsNotification");
		this.$store.commit("setReadAvalibleEventsNotificationTrigger");
		this.automatically = this.getOnDemandAutomaticAssignmentValue;
		this.enableOnDemandAutomaticAssignmentAlert = this.automatically;
		this.clock();
	},
	beforeDestroy() {
		const res = new Resource({});
		this.$store.commit("moduleResource/CLEAR_RESOURCES");
		this.$store.commit("moduleSchedule/SELECTED_RESOURCE", res);
		// Clears the timeout for the OnDemand component.
		clearTimeout(this.timeOut);
	},
	beforeCreate() {
		this.$store.commit("moduleResource/CLEAR_RESOURCES");
	},
};
</script>

<style lang="scss" scoped>
.scroll-area--content-left {
	margin: auto;
	width: 100%;
	min-height: 450px;
	max-height: 490px;
	padding-bottom: 10px;
}

/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
	transition: all 0.3s ease;
}
.slide-fade-leave-active {
	transition: all 0.1s cubic-bezier(1, 0.5, 0.8, 1);
	background: chocolate;
}
.slide-fade-enter,
.slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
	transform: translateX(200px);
	opacity: 0;
}

.events-sidebar {
	::v-deep .vs-sidebar {
		width: 450px;
		max-width: 90vw;
	}
}
</style>
